// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ClaimItemProposalDTO } from './claim-item-proposal-dto';
import { OrderWithOrderCustomersDTO } from './order-with-order-customers-dto';

/**
 * 
 * @export
 * @interface ClaimProposalDTO
 */
export interface ClaimProposalDTO {
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    claimId: string;
    /**
     * 
     * @type {Array<ClaimItemProposalDTO>}
     * @memberof ClaimProposalDTO
     */
    itemProposals: Array<ClaimItemProposalDTO>;
    /**
     * 
     * @type {number}
     * @memberof ClaimProposalDTO
     */
    round: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    source: ClaimProposalDTOSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    status: ClaimProposalDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    type: ClaimProposalDTOTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimProposalDTO
     */
    autoResponded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    respondentUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    responseDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    publishedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    createdByUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    publishedByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    orderId?: string;
    /**
     * 
     * @type {OrderWithOrderCustomersDTO}
     * @memberof ClaimProposalDTO
     */
    order?: OrderWithOrderCustomersDTO;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimProposalDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ClaimProposalDTOSourceEnum {
    SUPPLIER = 'SUPPLIER',
    TENANT = 'TENANT'
}
/**
    * @export
    * @enum {string}
    */
export enum ClaimProposalDTOStatusEnum {
    DRAFT = 'DRAFT',
    AWAITINGRESPONSE = 'AWAITING_RESPONSE',
    AWAITINGPAYMENT = 'AWAITING_PAYMENT',
    SETTLED = 'SETTLED',
    COUNTERED = 'COUNTERED',
    DISPUTED = 'DISPUTED'
}
/**
    * @export
    * @enum {string}
    */
export enum ClaimProposalDTOTypeEnum {
    INITIAL = 'INITIAL',
    INTERMEDIATE = 'INTERMEDIATE',
    FINAL = 'FINAL'
}



